jQuery(function($) {
    if ($('.switcher').length == 0) {
        return;
    }

    $(document).on('click', '.switcher__option', function(){
        let switcher = $(this).data('switcher');
        let $switcher = $(this).closest('.switcher');
        $switcher.find('.switcher__option').removeClass('active');

        if (switcher){
            $('[data-switcher-id="' + switcher + '"').removeClass('active');
        }
        

        $('.switcher__option[data-switcher="' + switcher + '"]').removeClass('active');
        $(this).addClass('active');

        let target = $(this).data('target');
        $('.switcher__target').removeClass('active');
        $('[data-target-id="' + target +'"]').addClass('active');
    });
});